import { useEffect, useState } from "react"
import usePricing from "../hooks/usePricing"
import MuzifyProCrownImage from "../assets/images/muzify-pro-crown.png"

const ProfileIcon = ({userInfo, isProfilePage}) => {

    const [isProUser, setIsProUser] = useState(false)
    const { fetchUserPaymentStatus } = usePricing()

    useEffect(() => {

        const getProStatus = async (uuid) => {
            try {
                const userPaymentStatus = await fetchUserPaymentStatus(uuid)
                if (userPaymentStatus) {
                    setIsProUser(true)
                }
            } catch (error) {
                console.log("Couldn't fetch pro status", error)
            }
        }

        if (userInfo) {
            getProStatus(userInfo.uuid)
        }

    }, [userInfo])

    return (
        userInfo ?
        (
            isProUser ? 
            (
                isProfilePage ? (
                    <div className="relative flex justify-center items-center">
                        <img
                            src={userInfo?.profilepic}
                            alt="user profile picture"
                            className="h-24 w-24 rounded-full bg-gray-800 border-[2px] border-[#FEC330] relative"
                        />

                        <img src={MuzifyProCrownImage} className="absolute left-0 -top-[40px] w-[60px] h-[60px]"/>
                    </div>
                )
                : (
                    <div className="relative flex justify-center items-center">
                        <img
                            src={userInfo?.profilepic}
                            alt="user profile picture"
                            className="h-8 w-8 md:h-12 md:w-12 rounded-full bg-gray-800 border-[2px] border-[#FEC330] relative"
                        />

                        <img src={MuzifyProCrownImage} className="absolute left-0 -top-[13.33px] md:-top-[20px] w-[20px] md:w-[30px] h-[20px] md:h-[30px]"/>
                    </div>
                )
            )
            :
            (
                isProfilePage ?
                (
                    <img
                        src={userInfo?.profilepic}
                        alt="user profile picture"
                        className="h-24 w-24 rounded-full"
                    />
                )
                :
                (
                    <img
                        src={userInfo?.profilepic}
                        alt="user profile picture"
                        className="h-8 w-8 md:h-12 md:w-12 rounded-full bg-gray-800"
                    />
                )
            )
        ) : <></>
    )
}

export default ProfileIcon
